const single_sign_on = {
    forbidden_domains: 'Domínios de e-mail público não são permitidos.',
    duplicated_domains: 'Existem domínios duplicados.',
    invalid_domain_format: 'Formato de domínio inválido.',
    duplicate_connector_name: 'O nome do conector já existe. Por favor, escolha um nome diferente.',
};
export default Object.freeze(single_sign_on);
